import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import type { FormModelFieldAssetType } from '../../form/form.asset.type';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export class ModelMutatorAssetType extends ModelMutator<FormModelField, CollectionModelFieldAssetType> {
	manual(title: string | null) {
		const option = this.field.schema.findAssetType(title);
		if (option == null || !option.visible) {
			this.state.setFieldValue<string>(this.field.id, null);
			return;
		}
		this.state.setFieldValue<string>(this.field.id, option.title);
	}

	/** Migrating/duplicating onto a schema where this title no longer exists or is now hidden drops the value instead of copying a dangling/unselectable reference. */
	override copy(from: CollectionModelFieldAssetType): boolean {
		if (!from.hasValue()) {
			this.manual(null);
			return true;
		}

		const value = from.value;
		const option = this.field.schema.findAssetType(value);
		if (option != null && option.visible) {
			this.manual(value);
			return true;
		}

		return false;
	}
}

export interface CollectionAssetTypeValue {
	icon: string;
	color: string;
	title: string;
}

export class CollectionModelFieldAssetType extends CollectionModelField<FormModelFieldAssetType, string> {
	static TYPE: IkeFieldType = IkeFieldType.ASSET_TYPE;

	static isAssetTypeField(f: CollectionModelField): f is CollectionModelFieldAssetType {
		return f.schema.type === CollectionModelFieldAssetType.TYPE;
	}

	private _Mutator: ModelMutatorAssetType;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorAssetType(this);
		}
		return this._Mutator;
	}

	override get value(): string | null {
		return this.stateValue ?? null;
	}

	override get displayValue(): string {
		return this.value ?? '';
	}

	get icon(): string | null {
		return this.schema.findAssetType(this.value)?.icon ?? null;
	}

	get color(): string | null {
		return this.schema.findAssetType(this.value)?.color ?? null;
	}

	hasValue(): boolean {
		return this.value != null && this.value !== '';
	}
}

registerFieldType(
	IkeFieldType.ASSET_TYPE,
	(parent, schema) => new CollectionModelFieldAssetType(parent, <FormModelFieldAssetType>schema)
);
